import React from "react";

export default function MySQL_SECOND() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MySQL_SECOND</h1>
      <p>This is the MySQL_SECOND component generated from the SQL JSON.</p>
    </div>
  );
}
